/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderSortingOption {
    DOCUMENT_NUMBER = 'DocumentNumber',
    CUSTOMER_NAME = 'CustomerName',
    ORDER_DATE = 'OrderDate',
}
